export class StringUtils {

  static getErrorMessage(error: any): string {
    const extracted: string = StringUtils.prettifyErrorMessage(StringUtils.extractErrorMessage(error));
    const pattern = new RegExp(/com\.(\w+\.)+\w+: /, 'gim');
    return extracted.replace(pattern, '');
  }

  static async getErrorMessageAsync(error: any): Promise<string> {
    if (error?.error instanceof Blob) {
      try {
        const text = await error.error.text();
        if (text?.trim()) {
          return StringUtils.getErrorMessage({ ...error, error: text });
        }
      } catch {
        // fall through
      }
    }
    if (typeof error?.error?.text === 'string' && error.error.text.trim()) {
      return StringUtils.getErrorMessage({ ...error, error: error.error.text });
    }
    return StringUtils.getErrorMessage(error);
  }

  private static extractErrorMessage(error: any): string {
    if (typeof error === 'string') {
      return error;
    } else if (typeof error?.error === 'string') {
      return error.error;
    } else if (typeof error?.message === 'string') {
      return error.message;
    } else {
      return 'An error has occurred, please contact your Customer Service Representative';
    }
  }

  private static prettifyErrorMessage(errorMessage: string): string {
    const globalIgnoreCaseMultiLine = 'gim';
    const searchText = 'Request failed with response code [0-9]{3} Error Message:';
    const dotNetErrorText = searchText + ' {"Message":"';
    const dotNetSearch = new RegExp(dotNetErrorText, globalIgnoreCaseMultiLine);
    if (dotNetSearch.test(errorMessage)) {
      return errorMessage.substring(dotNetSearch.lastIndex).replace('"}', '');
    }
    const search: RegExp = new RegExp(searchText, globalIgnoreCaseMultiLine);
    if (search.test(errorMessage)) {
      return errorMessage.substring(search.lastIndex);
    } else {
      return errorMessage;
    }
  }

  static equalsIgnoreCase(first: string, second: string): boolean {
    const parsedFirst = (first?.toUpperCase()?.trim() || undefined);
    const parsedSecond = (second?.toUpperCase()?.trim() || undefined);
    if (!parsedFirst || !parsedSecond) {
      return false;
    }
    return parsedFirst === parsedSecond;
  }

  static isEmptyNumericValue(value: number): boolean {
    return value === null || value === undefined || isNaN(+value);
  }

  static isZeroOrEmpty(input: number): boolean {
    return this.isEmptyNumericValue(input) || input === 0;
  }

  static isBlank(input: any): boolean {
    return (input?.toString()?.trim()?.length || 0) === 0;
  }

  static isNotBlank(input: any): boolean {
    return !StringUtils.isBlank(input);
  }

  static formatErrorMessage(error: any): string {
    if (StringUtils.isNotBlank(error?.error)) {
      return StringUtils.prettifyErrorMessage(error.error);
    } else if (StringUtils.isNotBlank(error?.message)) {
      return StringUtils.prettifyErrorMessage(error.message);
    } else {
      return 'An error has occurred.  Please contact Customer Service';
    }
  }
}
